module.exports = __webpack_public_path__ + "img/water_info.6edb1606.png";